module.exports = __webpack_public_path__ + "static/3-d4cc4006716be71606c0e1b82f07ea40.jpg";